import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/scrollAnimations.css';
import './ChannelNodes.css';

const outerNodes = [
  { id: 'meta',      label: 'Facebook',   angle: 0,   icon: 'M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z', color: '#4267B2' },
  { id: 'linkedin',  label: 'LinkedIn',   angle: 60,  icon: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z', color: '#0A66C2' },
  { id: 'instagram', label: 'Instagram',  angle: 120, icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z', color: '#E1306C' },
  { id: 'email',     label: 'Email',      angle: 180, icon: 'email', color: '#EA4335' },
  { id: 'google',    label: 'Google', angle: 240, icon: 'M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z', color: '#4285F4' },
  { id: 'analytics', label: 'Analytics',  angle: 300, icon: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z', color: '#4285F4' },
];

const innerNodes = [
  { id: 'website',  label: 'Website',  angle: 30,  icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z', color: '#6da7ed' },
  { id: 'slack',    label: 'Slack',    angle: 150, icon: 'slack', color: '#6da7ed' },
  { id: 'calendar', label: 'Calendly', angle: 270, icon: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z', color: '#6da7ed' },
];

const cx = 50, cy = 50, outerR = 42, innerR = 22;

const getPos = (angle, radius) => ({
  x: cx + radius * Math.sin((angle * Math.PI) / 180),
  y: cy - radius * Math.cos((angle * Math.PI) / 180),
});

const allNodes = [
  ...outerNodes.map(n => ({ ...n, ...getPos(n.angle, outerR), ring: 'outer' })),
  ...innerNodes.map(n => ({ ...n, ...getPos(n.angle, innerR), ring: 'inner' })),
  { id: 'hub', label: 'BonusClub', x: cx, y: cy, ring: 'center', color: '#6da7ed' },
];

const getNode = (id) => allNodes.find(n => n.id === id);

const connections = [
  ...outerNodes.map((n, i) => [n.id, outerNodes[(i + 1) % 6].id]),
  ...innerNodes.map((n, i) => [n.id, innerNodes[(i + 1) % 3].id]),
  ...innerNodes.map(n => [n.id, 'hub']),
  ['website', 'meta'], ['website', 'linkedin'],
  ['slack', 'instagram'], ['slack', 'email'],
  ['calendar', 'google'], ['calendar', 'analytics'],
];

const ChannelNodes = () => {
  const { language } = useLanguage();
  const t = translations[language].channelNodes;
  const [graphRef, graphVisible] = useScrollAnimation({ threshold: 0.1 });
  const [textRef, textVisible] = useScrollAnimation({ threshold: 0.2 });
  const [isAI, setIsAI] = useState(true);
  const activePanelLabel = isAI ? t.aiPanelLabel : 'pipeline_diagnostic.sys';

  const sectionRef = useRef(null);
  const backlightRef = useRef(null);
  const rafRef = useRef(null);
  const btnOldRef = useRef(null);
  const btnNewRef = useRef(null);
  const [sliderStyle, setSliderStyle] = useState({});

  useEffect(() => {
    const updateSlider = () => {
      const btnOld = btnOldRef.current;
      const btnNew = btnNewRef.current;
      if (!btnOld || !btnNew) return;
      const active = isAI ? btnNew : btnOld;
      const wrap = active.parentElement;
      const wrapRect = wrap.getBoundingClientRect();
      const activeRect = active.getBoundingClientRect();
      setSliderStyle({
        width: activeRect.width,
        transform: `translateX(${activeRect.left - wrapRect.left - 4}px)`,
      });
    };
    updateSlider();
    window.addEventListener('resize', updateSlider);
    return () => window.removeEventListener('resize', updateSlider);
  }, [isAI, language]);

  const handleScroll = useCallback(() => {
    if (!sectionRef.current || !backlightRef.current) return;
    const rect = sectionRef.current.getBoundingClientRect();
    const vh = window.innerHeight;
    const progress = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
    const scale = 0.8 + progress * 0.4;
    const opacity = Math.min(1, progress * 1.8);
    const blur = 60 - progress * 20;
    backlightRef.current.style.opacity = opacity;
    backlightRef.current.style.transform = `translate(-50%, -50%) scale(${scale})`;
    backlightRef.current.style.filter = `blur(${blur}px)`;
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(handleScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [handleScroll]);

  return (
    <section id="how-it-works" ref={sectionRef} className="chnodes-section">
      <div ref={backlightRef} className="chnodes-backlight" />
      <div className="chnodes-inner">
        <div
          ref={graphRef}
          className={`chnodes-graph-wrap ${graphVisible ? 'chnodes-visible' : ''}`}
        >
          <div className="chnodes-graph">
            <div className="chnodes-orbit chnodes-orbit-outer" />
            <div className="chnodes-orbit chnodes-orbit-inner" />
            <div className="chnodes-center-glow" />

            <svg className="chnodes-svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
              <defs>
                {allNodes.filter(n => n.ring !== 'center').map(node => (
                  <radialGradient key={`grad-${node.id}`} id={`grad-${node.id}`} cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor={node.color} stopOpacity="0.3" />
                    <stop offset="100%" stopColor={node.color} stopOpacity="0" />
                  </radialGradient>
                ))}
                <radialGradient id="grad-hub" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stopColor="#6da7ed" stopOpacity="0.25" />
                  <stop offset="100%" stopColor="#6da7ed" stopOpacity="0" />
                </radialGradient>
              </defs>

              {connections.map(([fromId, toId], i) => {
                const from = getNode(fromId);
                const to = getNode(toId);
                const isToCenter = toId === 'hub';
                const isInnerBridge = from.ring === 'outer' && to.ring === 'inner';
                return (
                  <line
                    key={i}
                    x1={from.x} y1={from.y}
                    x2={to.x} y2={to.y}
                    className={`chnodes-line ${isToCenter ? 'chnodes-line-center' : ''} ${isInnerBridge ? 'chnodes-line-bridge' : ''}`}
                    style={{ animationDelay: `${0.3 + i * 0.04}s` }}
                  />
                );
              })}

              {/* Particles: inner → hub */}
              {connections.filter(([, toId]) => toId === 'hub').map(([fromId], i) => {
                const from = getNode(fromId);
                return (
                  <circle
                    key={`p-in-${i}`}
                    r="0.6"
                    fill="#6da7ed"
                    opacity="0"
                    className="chnodes-particle"
                  >
                    <animateMotion
                      dur={`${2.5 + i * 0.4}s`}
                      repeatCount="indefinite"
                      path={`M${from.x},${from.y} L${cx},${cy}`}
                    />
                    <animate attributeName="opacity" values="0;0.6;0.6;0" keyTimes="0;0.1;0.8;1" dur={`${2.5 + i * 0.4}s`} repeatCount="indefinite" />
                    <animate attributeName="r" values="0.3;0.7;0.3" dur={`${2.5 + i * 0.4}s`} repeatCount="indefinite" />
                  </circle>
                );
              })}

              {/* Particles: hub → inner (outward from center) */}
              {connections.filter(([, toId]) => toId === 'hub').map(([fromId], i) => {
                const to = getNode(fromId);
                return (
                  <circle
                    key={`p-out-${i}`}
                    r="0.5"
                    fill="#6da7ed"
                    opacity="0"
                    className="chnodes-particle"
                  >
                    <animateMotion
                      dur={`${3.0 + i * 0.5}s`}
                      begin={`${1.2 + i * 0.3}s`}
                      repeatCount="indefinite"
                      path={`M${cx},${cy} L${to.x},${to.y}`}
                    />
                    <animate attributeName="opacity" values="0;0.5;0.5;0" keyTimes="0;0.1;0.8;1" dur={`${3.0 + i * 0.5}s`} begin={`${1.2 + i * 0.3}s`} repeatCount="indefinite" />
                    <animate attributeName="r" values="0.3;0.6;0.3" dur={`${3.0 + i * 0.5}s`} begin={`${1.2 + i * 0.3}s`} repeatCount="indefinite" />
                  </circle>
                );
              })}

              {/* Particles: inner → outer (along bridge lines) */}
              {[
                ['website', 'meta'], ['website', 'linkedin'],
                ['slack', 'instagram'], ['slack', 'email'],
                ['calendar', 'google'], ['calendar', 'analytics'],
              ].map(([fromId, toId], i) => {
                const from = getNode(fromId);
                const to = getNode(toId);
                return (
                  <circle
                    key={`p-bridge-${i}`}
                    r="0.45"
                    fill="#6da7ed"
                    opacity="0"
                    className="chnodes-particle"
                  >
                    <animateMotion
                      dur={`${3.5 + i * 0.3}s`}
                      begin={`${0.5 + i * 0.4}s`}
                      repeatCount="indefinite"
                      path={`M${from.x},${from.y} L${to.x},${to.y}`}
                    />
                    <animate attributeName="opacity" values="0;0.45;0.45;0" keyTimes="0;0.1;0.8;1" dur={`${3.5 + i * 0.3}s`} begin={`${0.5 + i * 0.4}s`} repeatCount="indefinite" />
                    <animate attributeName="r" values="0.25;0.55;0.25" dur={`${3.5 + i * 0.3}s`} begin={`${0.5 + i * 0.4}s`} repeatCount="indefinite" />
                  </circle>
                );
              })}

              {allNodes.filter(n => n.ring !== 'center').map(node => (
                <circle
                  key={`glow-${node.id}`}
                  cx={node.x}
                  cy={node.y}
                  r="5"
                  fill={`url(#grad-${node.id})`}
                  className="chnodes-node-glow"
                />
              ))}
              <circle cx={cx} cy={cy} r="8" fill="url(#grad-hub)" className="chnodes-node-glow chnodes-hub-glow-svg" />
            </svg>

            {allNodes.map((node, i) => (
              <div
                key={node.id}
                className={`chnodes-node chnodes-node-${node.ring}`}
                style={{
                  left: `${node.x}%`,
                  top: `${node.y}%`,
                  animationDelay: `${0.2 + i * 0.06}s`,
                  '--node-color': node.color,
                }}
              >
                {node.ring === 'center' ? (
                  <div className="chnodes-hub">
                    <img src="./img/bonusclub_icon.svg" alt="BonusClub" className="chnodes-hub-logo" />
                  </div>
                ) : (
                  <>
                    <div className="chnodes-icon">
                      <svg viewBox="0 0 24 24" width="20" height="20">
                        {node.icon === 'email' ? (
                          <>
                            <rect x="2" y="4" width="20" height="16" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                            <polyline points="22,6 12,13 2,6" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                          </>
                        ) : node.icon === 'slack' ? (
                          <>
                            <rect x="4" y="4" width="6" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                            <rect x="14" y="4" width="6" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                            <rect x="4" y="14" width="6" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                            <rect x="14" y="14" width="6" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                          </>
                        ) : (
                          <path d={node.icon} fill="currentColor" />
                        )}
                      </svg>
                    </div>
                    <span className="chnodes-nodelabel">{node.label}</span>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>

        <div
          ref={textRef}
          className={`chnodes-text scroll-fade-in ${textVisible ? 'is-visible' : ''}`}
        >
          <span className="section-label">{isAI ? t.labelAI : t.label}</span>
          <h2 className={`chnodes-title chnodes-title-swap ${isAI ? 'chnodes-title-ai' : ''}`}>
            {isAI ? (
              <><span className="chnodes-title-highlight">{t.titleAIHighlight}</span>{t.titleAIRest}<br />{t.titleAIRest2}</>
            ) : (
              <><span className="chnodes-title-problem">{t.titleHighlight}</span><br />{t.titleRest}</>
            )}
          </h2>
          <p className={`chnodes-desc chnodes-desc-swap ${isAI ? 'chnodes-desc-ai' : ''}`}>
            {isAI ? t.descriptionAI : t.description}
          </p>

          <div className="chnodes-toggle-wrap">
            <button
              ref={btnOldRef}
              className={`chnodes-toggle-btn ${!isAI ? 'chnodes-toggle-active' : ''}`}
              onClick={() => setIsAI(false)}
            >
              {t.toggleOld}
            </button>
            <button
              ref={btnNewRef}
              className={`chnodes-toggle-btn chnodes-toggle-btn-ai ${isAI ? 'chnodes-toggle-active' : ''}`}
              onClick={() => setIsAI(true)}
            >
              <svg className="chnodes-toggle-icon" viewBox="0 0 16 16" fill="none">
                <path d="M8.5 1L3 9h4.5L7 15l6-8H8.5L9 1z" fill="currentColor" />
              </svg>
              {t.toggleNew}
            </button>
            <div
              className={`chnodes-toggle-slider ${isAI ? 'chnodes-toggle-slider-ai' : ''}`}
              style={sliderStyle}
            />
          </div>

          <div
            className={`chnodes-panel ${isAI ? 'chnodes-panel-ai' : ''}`}
            style={{
              boxShadow: isAI
                ? '0 0 80px 20px rgba(50, 130, 200, 0.15), 0 0 160px 60px rgba(40, 100, 180, 0.08)'
                : '0 0 80px 20px rgba(200, 50, 50, 0.15), 0 0 160px 60px rgba(180, 40, 40, 0.08)',
              transition: 'box-shadow 0.5s ease',
            }}
          >
            <div className={`chnodes-panel-header ${isAI ? 'chnodes-panel-header-ai' : ''}`}>
              <div className="chnodes-panel-dots">
                <span className={`chnodes-pdot ${isAI ? 'chnodes-pdot-green' : 'chnodes-pdot-red'}`} />
                <span className={`chnodes-pdot ${isAI ? 'chnodes-pdot-green-dim' : 'chnodes-pdot-yellow'}`} />
                <span className="chnodes-pdot chnodes-pdot-dim" />
              </div>
              <span className="chnodes-panel-label">{activePanelLabel}</span>
            </div>

            <div className="chnodes-panel-body">
              <div className={`chnodes-panel-layer ${!isAI ? 'chnodes-panel-layer-active' : ''}`}>
                <div className="chnodes-kpi-row">
                  {t.stats.map((stat, i) => (
                    <div key={i} className="chnodes-kpi" style={{ '--kpi-idx': i }}>
                      <div className="chnodes-kpi-top">
                        <span className="chnodes-kpi-value">{stat.value}</span>
                        <span className="chnodes-kpi-badge">ALERT</span>
                      </div>
                      <span className="chnodes-kpi-label">{stat.label}</span>
                      <div className="chnodes-kpi-bar">
                        <div className="chnodes-kpi-bar-fill" style={{ width: i === 0 ? '78%' : i === 1 ? '37%' : '83%' }} />
                      </div>
                      <span className="chnodes-kpi-source">{stat.source}</span>
                    </div>
                  ))}
                </div>

                <div className="chnodes-diag-divider" />

                <div className="chnodes-diag-rows">
                  {t.painCards.map((card, i) => (
                    <div key={i} className={`chnodes-diag-row chnodes-diag-${card.status}`} style={{ '--row-idx': i }}>
                      <div className="chnodes-diag-severity">
                        <div className={`chnodes-diag-dot chnodes-ddot-${card.status}`} />
                      </div>
                      <div className="chnodes-diag-content">
                        <h4 className="chnodes-diag-title">{card.title}</h4>
                        <p className="chnodes-diag-text">{card.text}</p>
                        {card.source && <span className="chnodes-diag-source">{card.source}</span>}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="chnodes-panel-footer">
                  <span>{t.sources}</span>
                </div>
              </div>

              <div className={`chnodes-panel-layer chnodes-panel-layer-ai ${isAI ? 'chnodes-panel-layer-active' : ''}`}>
                <div className="chnodes-kpi-row">
                  {t.aiStats.map((stat, i) => (
                    <div key={i} className="chnodes-kpi chnodes-kpi-ai" style={{ '--kpi-idx': i }}>
                      <div className="chnodes-kpi-top">
                        <span className="chnodes-kpi-value chnodes-kpi-value-ai">{stat.value}</span>
                        <span className="chnodes-kpi-badge chnodes-kpi-badge-ai">LIVE</span>
                      </div>
                      <span className="chnodes-kpi-label">{stat.label}</span>
                      <div className="chnodes-kpi-bar">
                        <div className="chnodes-kpi-bar-fill chnodes-kpi-bar-fill-ai" style={{ width: i === 0 ? '95%' : i === 1 ? '97%' : '100%' }} />
                      </div>
                      <span className="chnodes-kpi-source">{stat.source}</span>
                    </div>
                  ))}
                </div>

                <div className="chnodes-diag-divider" />

                <div className="chnodes-diag-rows">
                  {t.aiCards.map((card, i) => (
                    <div key={i} className={`chnodes-diag-row chnodes-diag-${card.status}`} style={{ '--row-idx': i }}>
                      <div className="chnodes-diag-severity">
                        <div className={`chnodes-diag-dot chnodes-ddot-${card.status}`} />
                      </div>
                      <div className="chnodes-diag-content">
                        <h4 className="chnodes-diag-title">{card.title}</h4>
                        <p className="chnodes-diag-text">{card.text}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="chnodes-panel-footer">
                  <span>{t.aiSources}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChannelNodes;
